// extracted by mini-css-extract-plugin
export var card = "_95-c";
export var checkmark = "_95-k";
export var childrenContainer = "_95-6";
export var container = "_95-b";
export var disabled = "_95-9";
export var disabledChildren = "_95-a";
export var focused = "_95-1";
export var gray = "_95-s";
export var green = "_95-p";
export var icon = "_95-g";
export var iconWrapper = "_95-8";
export var imageCircle = "_95-u";
export var large = "_95-5";
export var lg = "_95-j";
export var listItemContainer = "_95-0";
export var md = "_95-i";
export var medium = "_95-4";
export var menu = "_95-f";
export var nonInteractiveBadge = "_95-m";
export var red = "_95-q";
export var rightArea = "_95-7";
export var sectionContainer = "_95-e _95-b";
export var selected = "_95-d";
export var sm = "_95-h";
export var small = "_95-3";
export var statusDot = "_95-o";
export var statusDotContainer = "_95-n";
export var text = "_95-l";
export var transparent = "_95-t";
export var xs = "_95-2";
export var yellow = "_95-r";